import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const PaystackCallback = () => {
  const [searchParams] = useSearchParams();
  const reference = searchParams.get("reference");

  useEffect(() => {
    if (reference) {
      fetch(`/api/verify-paystack-payment?reference=${reference}`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            alert("Payment successful!");
          } else {
            alert("Payment failed. Please try again.");
          }
        })
        .catch(() => alert("Something went wrong!"));
    }
  }, [reference]);

  return <h2>Processing Payment...</h2>;
};

export default PaystackCallback;
